module.exports = __webpack_public_path__ + "img/purple.16b3e57d.svg";